import { NewPractitionerPage } from '@/pages/Practitioners/NewPractitioner';
import { createFileRoute } from '@tanstack/react-router';

const RouteComponent = (): React.ReactNode => {
  return <NewPractitionerPage />;
};

export const Route = createFileRoute('/_auth/practitioners/new')({
  component: RouteComponent,
  loader: () => ({ crumb: 'New practitioner' }),
});
